import React from 'react';

import EmailVerificationCard from '#/EmailVerification/EmailVerificationCard';
import { WizardStep } from '#/models/WizardStep.enum';
import { DeliveryCard } from '../Delivery/DeliveryCard';

const WizardBody = ({ currentStep }: { currentStep: WizardStep }) => {
  switch (currentStep) {
    case WizardStep.Confirm:
    case WizardStep.Update:
    case WizardStep.Validate:
      return <EmailVerificationCard />;
    case WizardStep.Deliver:
      return <DeliveryCard />;
    default:
      return null;
  }
};

export default WizardBody;
